import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from "./store/auth/";
import settings from "./store/settings/";
import users from "./store/users/";
import general from "./store/general/";
import applications from "./store/applications/";
import deployments from "./store/deployments/";
import devices from "./store/devices/";
import events from "./store/events/";
import organizations from "./store/organizations/";
import ownerships from "./store/ownerships/";
import rock7 from "./store/rock7/";
import deviceTypes from "./store/deviceTypes/";
import statistics from "./store/statistics/";
import adminConfig from "./store/adminConfig/";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    settings,
    users,
    general,
    applications,
    deployments,
    devices,
    events,
    organizations,
    ownerships,
    rock7,
    deviceTypes,
    statistics,
    adminConfig
  },
  plugins: [
    createPersistedState({
      paths: [
        "auth",
        "settings",
        "users",
        "general",
        "applications",
        "organizations",
        "deviceTypes"
      ]
    })
  ]
});
